import { combineReducers } from 'redux';

import appointment from './appointment';
import bookableAppointments from './bookableAppointments';
import contactForm from './contactForm';
import giftCard from './giftCardReducer';
import location from './location';
import publicUser from './publicUser';
import selectedProfessional from './selectedProfessional';
import selectedServiceCategory from './selectedServiceCategory';
import selectedServices from './selectedServices';

const rootReducer = combineReducers({
  contactForm,
  bookableAppointments,
  location,
  publicUser,
  selectedServices,
  selectedProfessional,
  appointment,
  giftCard,
  selectedServiceCategory,
});

export type TGlobalState = ReturnType<typeof rootReducer>;

export default rootReducer;
